import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<any>
  ) { }
  ngOnInit(): void {
  }
  closeModel() {
    this.dialogRef.close({
    });
  }
}
